import { render, staticRenderFns } from "./LegacyReferralsBlock.vue?vue&type=template&id=5ae03c00&"
import script from "./LegacyReferralsBlock.vue?vue&type=script&lang=ts&"
export * from "./LegacyReferralsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports